import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useQuestionIdentifiersQuery } from "../../services/shared/api";
import {
  selectActiveReportingPeriodProperlyInitialized,
  selectReportingPeriodLoading,
} from "../../services/submissionPeriod/slices";
import {
  selectCurrentFormDataS3Path,
  selectLoadingStatusForId,
} from "../../services/form/slices";
import { STATUSES } from "../../util/constants";
import {
  selectQuestionIDs,
  selectUserIsGMSAuthorized,
} from "../../services/storage/slices";
import useReadOnlyMode from "./useReadOnlyMode";

const selectIndividualFormDataLoading = (state, id) => {
  const formApiStatus = selectLoadingStatusForId(state, id);
  return formApiStatus === STATUSES.LOADING;
};

function useSubmissionInitializer() {
  const { type, id } = useParams();
  const storedS3Path = useSelector((state) => {
    return id && selectCurrentFormDataS3Path(state, type, id);
  });
  const { readOnly } = useReadOnlyMode()
  
  const okToLoadJSON = useSelector((state) => {
    const isAuthorized = selectUserIsGMSAuthorized(state);
    if (!isAuthorized) {
      return false;
    }
    if (storedS3Path) {
      return true;
    }

    if (id) {
      const formLoading = selectIndividualFormDataLoading(state, id);
      if (formLoading) {
        return false;
      }
    }
    const activeReportPeriodSetUp =
      selectActiveReportingPeriodProperlyInitialized(state);
    return activeReportPeriodSetUp;
  });
  const { isLoading: questionsAreLoading, data: questionIDData } =
    useQuestionIdentifiersQuery(
      {
        s3Path: storedS3Path,
        formType: type,
        formId: id,
      },
      {
        skip: !okToLoadJSON,
      }
    );

  const identifiers = useSelector(
    (state) => {
      if (questionIDData?.length) {
        return questionIDData;
      }
      const qIds = selectQuestionIDs(state, { type, identifier: id, path: storedS3Path });
      return Array.isArray(qIds) ? qIds : [];
    },
    (a, b) => a.join() === b.join()
  );

  const showLoader = useSelector((state) => {
    if (id) {
      if (selectIndividualFormDataLoading(state, id)) {
        return true;
      }
    }
    const activePeriodLoading = selectReportingPeriodLoading(state);
    return activePeriodLoading || questionsAreLoading;
  });

  return {
    readOnly,
    isLoading: showLoader,
    identifiers,
  };
}

export default useSubmissionInitializer;
